<template>
  <v-sheet :height="'100%'" class="d-flex flex-column align-center pa-4">
    <MainCard
      title="AI Studio"
      subtitle="Potencialize sua estratégia com o AI Studio. Utilize ferramentas avançadas integradas ao Rubeus para tomar decisões baseadas em dados, personalizar o relacionamento com seus contatos e ganhar agilidade no dia a dia da sua equipe."
    >
      <v-sheet class="d-flex ">
        <NavigationCard
          :items="items"
          md="4"
          lg="4"
          xlg="4"
          titlecolor="#505353"
          titlefontfamily="Roboto"
          titlefontsize="16px"
          titlefontstyle="normal"
          titlefontweight="500"
          titlelineheight="23.4px"
          typecolor=""
          typefontfamily=""
          typefontsize=""
          typefontstyle=""
          typefontweight=""
          typelineheight=""
          desccolor="#505353"
          descfontfamily="Roboto"
          descfontsize="14px"
          descfontstyle="normal"
          descfontweight="400"
          desclineheight="20px"
          backgroudColor="#FBFDFC"
          :isHome="true"
          actionActive="1"
          :showAccessAction="true"
          :showToggleAction="false"
          @access="handleAccess"
        />

        <RbPopupInsightsHiring
          v-model="insightsHiring.popupOpen"
          @hired="handleInsightsHired"
        />
      </v-sheet>
    </MainCard>
  </v-sheet>
</template>

<script setup>
import { onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import MainCard from '@/ai_studio/components/layout/MainCard.vue'
import NavigationCard from '../components/common/NavigationCard.vue'
import RbPopupInsightsHiring from '@/captacao/components/hiring/RbPopupInsightsHiring.vue'

import { useInsightsHiringStore } from '@/ai_studio/stores/insightsHiring.store'
import { useUserStore } from '@/ai_studio/stores/user'
import { PERMISSIONS } from '@/ai_studio/constants/permissions'

const route = useRoute()
const router = useRouter()
const userStore = useUserStore()
const insightsHiring = useInsightsHiringStore()

const appMap = {
  Assistentes: {
    route: '/assistentes',
    permission: PERMISSIONS.ASSISTENTES,
  },

  Insights: {
    route: '/model',
    permission: PERMISSIONS.INSIGHTS,
  },

  'Geração de conteúdo': {
    route: '/content-generation',
    permission: PERMISSIONS.GERACAO_CONTEUDO,
  },

  'Monitoramento de Recursos': {
    route: '/resources-dashboard',
    permission: PERMISSIONS.MONITORAMENTO_USO,
  },
}

const getAppConfig = (item) => {
  return appMap[item?.name] || null
}

const canShowApp = (item) => {
  const appConfig = getAppConfig(item)
  const permission = item?.permission || appConfig?.permission

  if (!permission) {
    return true
  }

  return userStore.hasPermission(permission)
}

const items = computed(() => {
  return (route.meta.apps ?? [])
    .map((item) => {
      const appConfig = getAppConfig(item)

      return {
        ...item,
        route: item.route || item.path || appConfig?.route,
        permission: item.permission || appConfig?.permission,
      }
    })
    .filter(canShowApp)
})

const isInsightsItem = (item) => {
  return item?.permission === PERMISSIONS.INSIGHTS
}

const handleAccess = async (item) => {
  if (item?.permission && !userStore.hasPermission(item.permission)) {
    router.push({ name: '403' })
    return
  }

  const targetRoute = item?.route || item?.path

  if (isInsightsItem(item)) {
    await insightsHiring.accessInsights(router, targetRoute || '/model')
    return
  }

  if (targetRoute) {
    router.push(targetRoute)
  }
}

const handleInsightsHired = async () => {
  await insightsHiring.markAsHired()
  insightsHiring.redirectAfterHiring(router, '/model')
}

onMounted(async () => {
  await insightsHiring.fetchStatus()
})
</script>
